var UploadFileFormModel = /** @class */ (function () {
    function UploadFileFormModel(items) {
        if (items === void 0) { items = {}; }
        var _a = items, _b = _a.fileName, fileName = _b === void 0 ? '' : _b, file = _a.file;
        this.fileName = fileName;
        this.file = file;
    }
    UploadFileFormModel.assign = function (data) {
        return new UploadFileFormModel(data);
    };
    return UploadFileFormModel;
}());
export { UploadFileFormModel };
